module.exports = __webpack_public_path__ + "img/promo.192976c9.png";